var map = {
	"./2008527909250131-150x150.jpg": 8901,
	"./2008527909250131.jpg": 7878,
	"./4-Way-Cross-Rim-Wrench-Large-150x150.jpg": 7051,
	"./4-Way-Cross-Rim-Wrench-Large.jpg": 2844,
	"./Angle-Socket-Wrench-Large-150x150.jpg": 3632,
	"./Angle-Socket-Wrench-Large.jpg": 2407,
	"./Cross-Rim-Wrench-Large-150x150.jpg": 4720,
	"./Cross-Rim-Wrench-Large.jpg": 3319,
	"./L-Shape-Angled-Spanners-Large-150x150.jpg": 6168,
	"./L-Shape-Angled-Spanners-Large.jpg": 2287,
	"./L-Type-Spanner-Large-150x150.jpg": 810,
	"./L-Type-Spanner-Large.jpg": 1681,
	"./Lug-Wrench-Large-150x150.jpg": 2325,
	"./Lug-Wrench-Large.jpg": 4454,
	"./MMUdyogLogo-150x150.png": 3570,
	"./MMUdyogLogo.png": 5845,
	"./Machine-2-150x150.jpg": 4569,
	"./Machine-2.jpg": 8546,
	"./Tommy-Bars-Large-150x150.jpg": 7362,
	"./Tommy-Bars-Large.jpg": 1801,
	"./Truck-Wheel-Wrench-Large-150x150.jpg": 9588,
	"./Truck-Wheel-Wrench-Large.jpg": 1315,
	"./Two-Way-Wheel-Spanner-Large-150x150.jpg": 1023,
	"./Two-Way-Wheel-Spanner-Large.jpg": 2936,
	"./angleSocketWrench-150x94.png": 2033,
	"./angleSocketWrench-300x73.png": 3411,
	"./angleSocketWrench.png": 1429,
	"./cropped-MMUdyogLogo1-150x150.png": 9545,
	"./cropped-MMUdyogLogo1.png": 8286,
	"./crossWheelSpanner-150x150.png": 255,
	"./crossWheelSpanner.png": 732,
	"./featured-image.png": 5168,
	"./iso-150x150.png": 3688,
	"./iso-226x300.png": 4241,
	"./iso-773x1024.png": 152,
	"./iso.png": 1683,
	"./iso1-150x150.png": 5669,
	"./iso1-230x300.png": 8785,
	"./iso1.png": 6754,
	"./lSpanner-150x97.png": 2078,
	"./lSpanner-300x75.png": 4169,
	"./lSpanner.png": 3593,
	"./location-150x150.png": 7684,
	"./location-300x174.png": 5379,
	"./location.png": 1863,
	"./machine1-150x150.jpg": 8125,
	"./machine1-240x300.jpg": 4208,
	"./machine1.jpg": 4830,
	"./mmudyogLogo1.png": 72,
	"./twoWayWheelSpanner-150x150.png": 8938,
	"./twoWayWheelSpanner-300x108.png": 4172,
	"./twoWayWheelSpanner.png": 5213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4432;